import * as React from 'reactn';
import {base, BaseColor, ButtonComponent, ComponentFactory, ComponentUtil, IBaseProps, StringUtil} from "oca-lib-web";
import Sidebar from "../component/Sidebar";
import {addCallback} from "reactn";
import AWSAuth from "../auth/aws/AWSAuth";
import 'react-bulma-components/dist/react-bulma-components.min.css';
import {createRef} from "react";
import AWSStorage from "../auth/aws/AWSStorage";
import VisualUtil from "../util/VisualUtil";
import Styles from "../style/Styles";
import StripeCheckout from 'react-stripe-checkout';

interface IState {
    componentFactory:ComponentFactory
}

class ProfilePage extends React.Component<IBaseProps, IState> {
    public appIssueDialog = createRef<any>();
    public componentRefs = ComponentUtil.createRefs(3);

    constructor() {
        super();

        let componentFactory = new ComponentFactory(Styles.default);

        this.state = {
            componentFactory:componentFactory
        };
    }

    async componentDidMount() {
        let componentFactory = this.state.componentFactory;
        addCallback(global => {
            componentFactory.addDefaultBinding(this.global.dataManager, "createUser", global.user);
            this.setState({componentFactory:componentFactory});
            return null;
        });
        if (this.global.user) {
            componentFactory.addDefaultBinding(this.global.dataManager, "createUser", this.global.user);
            this.setState({componentFactory:componentFactory});
        }
    }

    updateData() {
        this.props.base.notify("Thank you! The NC Farms app team will look into your issue and respond to you soon");
    }

    // Methods

    async uploadPictureTapped(e:any) {
        if (!e.nativeEvent.target || !e.nativeEvent.target.files) { return }

        const file = e.nativeEvent.target.files[0];
        const fileName = StringUtil.uuid();
        await AWSStorage.put(fileName, file);
        console.log("uploaded file: " + fileName);

        let componentBinding = this.state.componentFactory.getDefaultBinding();
        componentBinding.setProperty("photo", fileName);
        this.forceUpdate();
        //componentBinding.saveBinding();
    }

    // Subscription

    async onTokenMonthly(token:any) {
        /*let item = {
            emailAddress: token.email,
            plan: process.env.REACT_APP_PLAN_MONTHLY,
            token: token.id,
            field: "createSubscription"
        }

        console.log(item);
        await DataAccess.createSubscription(item);*/
        this.updateSubscription(token, "monthly", process.env.REACT_APP_PLAN_MONTHLY);
    };

    async onTokenYearly(token:any) {
        this.updateSubscription(token, "yearly", process.env.REACT_APP_PLAN_MONTHLY);
    }

    async updateSubscription(token:any, planName:string, planId:string) {
        let item = {
            emailAddress: token.email,
            plan: planId,
            token: token.id,
            field: "createSubscription"
        }

        console.log(item);
        let subscription = await this.global.dataManager.save("createSubscription", item);
        console.log("subscriptionId: ");
        console.log(subscription);

        //this.updateUser(planName, subscription.subscriptionId);
        // TODO: Get user and update
    }

    getSubscriptionRow(item:any) {
        console.log(this.global.user?.plan)
        let name = item.label === "Monthly Subscription" ? "MONTHLY" : item.label === "Annual Subscription" ? "ANNUAL" : "";
        let description = item.label === "Monthly Subscription" ? "$1 / month" : item.label === "Annual Subscription" ? "$2 / month" : "";
        let amount = item.label === "Monthly Subscription" ? 100 : item.label === "Annual Subscription" ? 200 : 0;
        let tokenCallback = item.label === "Monthly Subscription" ? this.onTokenMonthly : item.label === "Annual Subscription" ? this.onTokenYearly : null;
        let currentPlan = item.label === "Monthly Subscription" && this.global.user && this.global.user?.plan === "monthly" ? true :
            item.label === "Annual Subscription" && this.global.user && this.global.user?.plan === "yearly";

        return [
            item.label,
            item.price,
            !currentPlan ? <StripeCheckout
                name={name}
                description={description}
                panelLabel="Pay"
                amount={amount}
                currency="USD"
                token={tokenCallback}
                stripeKey={process.env.REACT_APP_STRIPE_KEY}>
                <ButtonComponent primary={true} title="Change Plan"/>
            </StripeCheckout> : <div>Current Plan</div>
        ];
    }

    renderSubscription() {
        let cf = this.state.componentFactory;
        var subscriptions = [
            {id: "monthly", label: "Monthly Subscription", price: "$11.99 / 4 weeks"},
            {id: "yearly", label: "Annual Subscription", price: "$99.00 / year"}
        ];
        //let paperStyle = {paddingTop: '50px', marginLeft: '10%', marginRight: '5%'}
        let headers = ["Plan", "Price", ""];

        return cf.renderTable(headers, subscriptions, this.getSubscriptionRow.bind(this));
    }

    // Save

    async saveButtonTapped(e:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding()
        if (!componentBinding.validate()) { return; }

        console.log(componentBinding.item);
        await componentBinding.saveBinding();
        this.props.base.notify("user saved successfully");
    }

    async logoutButtonTapped(e:any) {
        this.global.dataManager.clear();
        await AWSAuth.signOut();
    }

    public render() {
        let cf = this.state.componentFactory;
        let actions = [
            cf.renderButton("Save Profile", this.saveButtonTapped.bind(this)),
            cf.renderBoxProps({marginLeft:'20px'}, null),
            cf.renderButton("Logout", this.logoutButtonTapped.bind(this), {isFlat:true})
        ]

        return (
            cf.renderBoxProps({fullHeight:true, background:BaseColor.WHITE}, [
                cf.renderBoxProps({marginLeft:'90px'}, [
                    VisualUtil.getHeaderDisplay("Profile", actions),
                    cf.renderLine(),
                    <br/>,
                    cf.renderSizedColumns("half", [
                        cf.renderBoxPadded(cf.renderTextField("email", "Administrator Email Address", this.componentRefs[0], null, {disabled:true, required:true})),
                        cf.renderBoxPadded(cf.renderTextField("name", "Administrator Name", this.componentRefs[1], null, {required:true}))
                    ], [
                        cf.renderBoxPadded(cf.renderTextField("phone", "Administrator Phone Number (XXX-XXX-XXXX)", this.componentRefs[2], null, {required:true}))
                    ]),
                    cf.renderLine(),
                    VisualUtil.getHeaderDisplay("Subscription"),
                    cf.renderLine(),
                    this.renderSubscription()
                ])
            ])
        )
    }
}

export default base(ProfilePage, Sidebar)